import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MtnaSearchBoxModule } from '@mtna/core-angular';
import { RdsVariableStateModule } from '@rds/shared-state-variable';

import { RdsCodesTableModule } from '../codes-table';
import { RdsDateFilterModule } from '../date-filter';
import { RdsFilterModule } from '../filter';
import { RdsNumericFilterModule } from '../numeric-filter';
import { RdsTextFilterModule } from '../text-filter';
import { RdsVariableInformationModule } from '../variable-information';
import { RdsVariableStatsModule } from '../variable-stats';
import { RdsVariableDetailsComponent } from './variable-details.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatTabsModule,
    MatTooltipModule,
    MtnaSearchBoxModule,
    RdsCodesTableModule,
    RdsDateFilterModule,
    RdsFilterModule,
    RdsNumericFilterModule,
    RdsTextFilterModule,
    RdsVariableInformationModule,
    RdsVariableStatsModule,
    RdsVariableStateModule,
  ],
  exports: [RdsVariableDetailsComponent],
  declarations: [RdsVariableDetailsComponent],
})
export class RdsVariableDetailsModule {}

export * from './variable-details.component';
